<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listservices" class="blue-grey-text text-darken-4 strong">Security Master: Services</router-link>
        >
        <span>View Portfolio</span>
      </section>
    </article>
    <h4>View Portfolio</h4>
    <table class="container">
      <tbody>
        <tr>
          <th>Recommendations</th>
          <td>
            <router-link :to="`/tickeradmin/viewrecommendations?portfolio_id=${portfolio.id}`">
              See Recommendations
            </router-link>
          </td>
        </tr>
        <tr>
          <th>Portfolio ID</th>
          <td>{{ portfolio.id }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ portfolio.name }}</td>
        </tr>
        <tr>
          <th>Slug</th>
          <td>{{ portfolio.slug }}</td>
        </tr>
        <tr>
          <th>Is Active</th>
          <td>
            <i class="fas fa-check-circle green-text" v-if="portfolio.active" />
            <i class="fas fa-times-circle red-text" v-else />
          </td>
        </tr>
        <tr>
          <th>Active Date</th>
          <td>{{ portfolio.active_date }}</td>
        </tr>
        <tr v-if="portfolio.inactive_date">
          <th>Inactive Date</th>
          <td>{{ portfolio.inactive_date }}</td>
        </tr>
        <tr v-if="portfolio.apx_portfolio_id">
          <th>APX Portfolio ID</th>
          <td>{{ portfolio.apx_portfolio_id }}</td>
        </tr>
        <tr>
          <th>Recommendation Type</th>
          <td>{{ portfolio.recommendation_type.name | titlecase }}</td>
        </tr>
        <tr v-if="portfolio.portfolio_type.name === 'options'">
          <th>Strategy</th>
          <td>{{ portfolio.strategy }}</td>
        </tr>
        <tr v-if="portfolio.portfolio_type.name === 'options'">
          <th>Multiplier</th>
          <td>{{ portfolio.multiplier }}</td>
        </tr>
        <tr>
          <th>Default Currency</th>
          <td>{{ portfolio.default_currency.name }}</td>
        </tr>
        <tr>
          <th>Benchmark</th>
          <td>{{ portfolio.benchmark.name }}</td>
        </tr>
        <tr>
          <th>Portfolio Type</th>
          <td>{{ portfolio.portfolio_type.name | titlecase }}</td>
        </tr>
        <tr>
          <th>Embargo Recs Until Publish</th>
          <td>
            <i class="fas fa-check-circle green-text" v-if="portfolio.embargo_recs_until_publish" />
            <i class="fas fa-times-circle red-text" v-else />
          </td>
        </tr>
        <tr v-if="portfolio.portfolio_type.id === 1">
          <th>Cash Commitment</th>
          <td>{{ portfolio.cash_commitment }}</td>
        </tr>
      </tbody>
    </table>
    <aside class="usm-add-portfolio-aside" v-show="$auth.hasRoles('admin', 'recs-admin')">
      <router-link to="/tickeradmin/addportfolio">
        <button class="btn-floating btn-large waves-effect waves-light teal accent-4">
          <i class="fas fa-plus" />
        </button>
        <label>Add Portfolio</label>
      </router-link>
    </aside>
    <aside class="usm-edit-portfolio-aside" v-show="$auth.hasRoles('admin', 'recs-admin')">
      <router-link :to="`/tickeradmin/editportfolio?portfolio_id=${portfolio.id}`">
        <button class="btn-floating btn-large waves-effect waves-light amber accent-3">
          <i class="fas fa-edit" />
        </button>
        <label>Edit Portfolio</label>
      </router-link>
    </aside>
    <aside class="usm-close-portfolio-aside" v-if="portfolio.active && portfolio.portfolio_type.name === 'notional'" v-show="$auth.hasRoles('admin')">
        <button class="btn-floating btn-large waves-effect waves-light amber accent-3 modal-trigger"
          data-target="portfolio-close-modal">
          <i class="fas fa-window-close" />
        </button>
        <label>Close Portfolio</label>
    </aside>
    <article id="portfolio-close-modal" class="modal">
      <section class="modal-content">
        <h4><strong>Closing Portfolio</strong> {{ portfolio.name }}</h4>
        <div class="row">
          <section class="input-field col s6">
            <input id="portfolio-close-asof-date"
                   type="text"
                   class="datepicker"
                   v-model="portfolio.inactive_date"
                   @change="portfolio.inactive_date = $event.target.value"
            >
            <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
              As of Date
            </label>
          </section>
        </div>
        <div class="unclickable">
          <h1 style="color: rgba(0, 0, 0, 0)">J</h1>
        </div>
      </section>
      <section class="modal-footer">
        <a class="modal-close btn grey waves-effect waves-light left">Cancel</a>
        <a class="btn green waves-effect waves-light" @click="closePortfolio">Save</a>
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TickerAdminViewPortfolio',
  components: {},
  props: {},
  data() {
    return {
      portfolio: {
        recommendation_type: { name: '' },
        portfolio_type: { name: '' },
        default_currency: {},
        benchmark: {},
      },
    };
  },
  computed: {
    portfolioId() {
      return Number(this.$route.query.portfolio_id);
    },
  },
  watch: {},
  methods: {
    async fetchPortfolio() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolio/?portfolio_id=${this.portfolioId}`);
      this.portfolio = data;
    },
    async closePortfolio() {
      if (!this.portfolio.inactive_date) {
        return this.toast('You must provide an as of date.', 'pink');
      }
      if (confirm(`Really, close ${this.portfolio.name}?`)) {
        const { data } = await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolio/${this.portfolioId}/close/`, {
          as_of: this.portfolio.inactive_date,
        });
        this.portfolio.active = false;
        this.toast(`Closed portfolio: ${this.portfolio.name}!`, 'green');
      }

      const modal = this.materialize.Modal.getInstance(document.getElementById('portfolio-close-modal'));
      modal.close();
    },
    initModal() {
      this.materialize.Modal.init(document.getElementById('portfolio-close-modal'), {
        preventScrolling: false,
        dismissible: false,
      });
    },
    initDatepicker() {
      const d = new Date();
      d.setDate(d.getDate() - 1);
      this.materialize.Datepicker.init(document.querySelectorAll('.datepicker'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        maxDate: d,
        onSelect() {},
      });
    },
  },
  mounted() {
    this.fetchPortfolio();
    this.initModal();
    this.initDatepicker();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

nav {
  padding-left: 20px;
}

.usm-add-portfolio-aside {
  position: absolute;
  top: 30px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}

.usm-edit-portfolio-aside {
  position: absolute;
  top: 150px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}

.usm-close-portfolio-aside{
  position: absolute;
  top: 270px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}
#portfolio-close-modal  {
    padding: 0;
    height: 70%;
}
#portfolio-close-modal .modal-content {
    position: absolute;
    height: calc(100% - 56px);
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
}

#portfolio-close-modal .modal-footer {
  border-top: 1px solid rgba(0,0,0,0.1);
  position: absolute;
  bottom: 0;
}
</style>
